import * as Sentry from "@sentry/react";


export const logEvent = (category: string, message: string, level: Sentry.SeverityLevel = "info", data: any = undefined) => {
    Sentry.addBreadcrumb({
        category: category,
        message: message,
        level: level,
        data: data
    });
}

export const configureUser = (email: string, companyId: string, companyName: string, language: string) => {
    Sentry.setUser({
        email,
        companyId,
        companyName,
        language
    });
}